import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const AllCompetitionPricing = () => {
  const [allExamNotesCompetitionPricing, setAllExamNotesCompetitionPricing] =
    useState([]);
  const [examCategories, setExamCategories] = useState([]);
  const [examCategoryId, setExamCategoryId] = useState();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleGoBack = () => {
    navigate("/exam-notes-pricing");
  };
  const handleAddPrice = () => {
    navigate("/exam-notes-pricing/add-competition-pricing");
  };
  const handleViewAllPrice = () => {
    navigate("/exam-notes-pricing/all-competition-pricing");
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/competitions`)
      .then((response) => {
        const examCategoriesData = response.data?.data || [];
        setExamCategories(examCategoriesData);
      })
      .catch((error) => console.log(error));
  }, []);
  const handleSearch = (e) => {
    e.preventDefault();
    axios
      .get(
        `${API_BASE_URL}/pricing/exam-notes?competitionId=${examCategoryId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        console.log(response?.data?.data);
        const data = response?.data?.data;
        setAllExamNotesCompetitionPricing(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEdit = (id) => {
    navigate(`/exam-notes-pricing/edit-competition-pricing/${id}`);
  };

  return (
    <div id="allcompititivenotes-inner-wrapper">
      <BiArrowBack
        onClick={handleGoBack}
        className="left-arrow-icon mt-3"
        style={{
          cursor: "pointer",
          marginLeft: "10px",
          fontSize: "25px",
          color: "#000", // Customize the color as needed
        }}
      />
      <div className="allcompititivenotes-header-div">
        <h5>All competition exam notes price</h5>
        <div className="allcompititivenotes-header-btns">
          <button className="add-compititive-note-btn" onClick={handleAddPrice}>
            + Add Price
          </button>
          <button
            className="all-compititive-notes-btn"
            onClick={handleViewAllPrice}
          >
            All Price
          </button>
        </div>
      </div>

      <form onSubmit={handleSearch} className="note-detail-form form-container">
        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Exam Category</label>
          <select
            className="new-chapter-dropdown"
            value={examCategoryId}
            onChange={(e) => setExamCategoryId(e.target.value)}
            required
          >
            <option value="">-Select Category-</option>
            {examCategories.map((examCategory, idx) => (
              <option key={idx} value={examCategory._id}>
                {examCategory.examCategory}
              </option>
            ))}
          </select>
        </div>

        <div className="form1-btns">
          <button className="btn-save">Search Price</button>
        </div>
      </form>

      <div className="allcompititivenotes-table-container">
        <h5>All Competition Price</h5>
        <table className="allcompititivenotes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Exam Category</th>
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {allExamNotesCompetitionPricing &&
              allExamNotesCompetitionPricing.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{item?.competitionId?.examCategory}</td>
                  <td>{item?.price}</td>

                  <td className="table-action-icons">
                    <i
                      className="fa-solid fa-file-pen"
                      onClick={() => handleEdit(item._id)}
                    ></i>
                    {/* &nbsp;&nbsp;
                    <i
                      className="fa-solid fa-trash-can"
                      onClick={() => handleDelete(item._id)}
                    ></i> */}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllCompetitionPricing;
